import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { CreateSubmissionDto, FormSubmission } from './types/types';

export class SubmissionsService {
  // 📌 POST /forms/:id/submit
  static async create(formId: string, dto: CreateSubmissionDto): Promise<FormSubmission> {
    const response: AxiosResponse<FormSubmission> = await AxiosService.post(`/submission/forms/${formId}/submit`, dto);
    return response.data;
  }

  // 📌 POST /forms/:id/submit
  static async createWithCondition(formId: string, dto: CreateSubmissionDto): Promise<FormSubmission> {
    const response: AxiosResponse<FormSubmission> = await AxiosService.post(`/submission/forms/${formId}/submit/condition`, dto);
    return response.data;
  }

  // 📌 GET /forms/:id/submissions
  static async findByForm(formId: string, from?: string, to?: string, rut?:string): Promise<FormSubmission[]> {
    const params = new URLSearchParams();
    if (from) params.append("from", from);
    if (to) params.append("to", to);
    if (rut) params.append("rut", rut);

    const response: AxiosResponse<FormSubmission[]> = await AxiosService.get(`/submission/forms/${formId}/submissions?${params.toString()}`);
    return response.data;
  }

  // 📌 GET /submissions/:id
  static async findOne(id: string): Promise<FormSubmission | null> {
    const response: AxiosResponse<FormSubmission> = await AxiosService.get(`/submission/${id}`);
    return response.data;
  }

  // 📌 GET /submissions/:id/pdf
  static async downloadPdf(id: string): Promise<Blob | null> {
    const response: AxiosResponse<Blob> = await AxiosService.get(`/submission/${id}/pdf`, {
      responseType: 'blob'
    });
    return response.data;
  }
}